<template>
  <div class="catalog-menu-listing-component cmlc ml-0">
    <div v-if="CatalogIsLoading">
      <loading-spinner />
    </div>
    <div v-else>
      <div class="pt-2 cmlc__nav">
        <ul class="cmlc__ul">
          <li v-for="category in authorizedCategories" :key="category.Id" class="cmlc__li">
            <router-link
              class="clmc__cat-link block-100 hmmc__menu-item"
              :to="{ name: 'CatalogListing', query: {currentCategoryId: category.Id}}"
              @mouseover.native="AttemptSetCurrentCatalog(category.Id)"
              @mouseenter.native="SetHoveringCategoryId(category.Id)"
              @mouseleave.native="SetHoveringCategoryId(-1)"
            >
              {{ category.Title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters }               from "vuex"
  import { CatalogService }           from "@/services/CatalogService"
  import { ErrorLogService }          from "@/services/ErrorLogService"
  import LoadingSpinner               from "@/components/Elements/LoadingSpinner"
  import { siteSectionsHelper }       from "@/components/mixins/siteSectionsHelper"
  import { brandAndRegionAuthHelper } from "@/components/mixins"

  export default {
    components: {
      LoadingSpinner
    },
    mixins: [siteSectionsHelper, brandAndRegionAuthHelper],
    props: {
      currentCatalog: {
        name: "",
        link: "",
        id: undefined,
        childCategories: []
      }
    },

    data: function() {
      return {
        categories: [],
        hoveringCategoryId: 0,
        megaMenuHoverDelay: 250
      }
    },
    computed: {
      ...mapGetters(["user", "activeAccountId", "CatalogRoot", "CatalogIsLoading"]),
      authorizedCategories() {
        if(this.CatalogIsLoading || !this.CatalogRoot){
          return [];
        }

        var authCategories = this.CatalogRoot.filter(x =>
          this.IsBrandRegionAuthorized(x.BrandAuth, x.RegionAuth)
        );
        return authCategories;
      },
    },
    updated(){
      this.SetInitialCurrentCatalog();
    },
    methods: {
      AttemptSetCurrentCatalog: function (categoryId) {
        let self = this
        setTimeout(function(){
          if(self.hoveringCategoryId === categoryId){
            self.SetCurrentCatalog(categoryId);
          }
        }, self.megaMenuHoverDelay);

      },
      SetInitialCurrentCatalog: function(){
        let initialCategory = this.authorizedCategories[0];
        if(initialCategory)
        {
          this.SetCurrentCatalog(initialCategory.Id);
        }
      },
      SetCurrentCatalog: function(categoryId){
        let passedCategory = this.CatalogRoot.find(x => x.Id === categoryId);
        if(passedCategory)
        {
          this.currentCatalog.id = passedCategory.Id
          this.currentCatalog.name = passedCategory.Title
          this.currentCatalog.link = `/Catalog/catalogListing?currentCategoryId=${passedCategory.Id}`
        }
      },
      SetHoveringCategoryId: function (categoryId) {
        this.hoveringCategoryId = categoryId
      }
    }
  }
</script>


<style>
.cmlc__li {
  padding: 1.5px;
  margin-bottom: 2px;
  &:last-child{
    margin-bottom: 0;
  }
}
.cmlc__ul{
  list-style: none;
  padding-left: 0px;
  font-size: 15px;
  line-height: normal;
}
.clmc__cat-link {
  font-weight: bold;
}
.cmlc__nav{
  background-color: #e0eaf3;
  height: 508px;
  text-align: left;
}

</style>
